import React, { Component } from 'react'
import moment from 'moment';
import { Datos_Empresa, FORMAT_NUMBER, CURRENCY } from "../../libs/utils/Const";
import { NumeroLetra } from '../NewOrder';
import { development } from "../../libs/utils/Const";

class DownPayment extends Component {

    render() {
        const { DocLines, DocHeader, InfoByFolio, reprint, user, time } = this.props;
        let XML = {};
        let xml = DocHeader.U_FMB_XMLTIMBRA ? DocHeader.U_FMB_XMLTIMBRA.includes('UUID') ? JSON.parse(DocHeader.U_FMB_XMLTIMBRA) : null : null;
        XML ={
            isTimbra: xml ? true : false,
            info: xml
        }
        let totalLetra = '';
        let cfdiCaComplemento = '';
        if(xml){
            let numeroLetra = new NumeroLetra();
            totalLetra = numeroLetra.NumeroALetras(xml._attributes.Moneda, Number(Number(DocHeader.DocTotal).toFixed(2)));
            cfdiCaComplemento = "||"+xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.Version +"|"+xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.UUID +"|"+xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.FechaTimbrado +"|"+xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.RfcProvCertif +"||"+xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.SelloCFD +"|"+xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.NoCertificadoSAT +"||";
        }else{
            let numeroLetra = new NumeroLetra();
            totalLetra = numeroLetra.NumeroALetras('SOL',Number(Number(DocHeader.DocTotal).toFixed(2)));
        }
        return (
            
                <table><tr><td>
                    <div>
                        <div className='mt-5' style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto" }}>
                        
                            <div className='text-right' style={{ fontSize: "14px" }}>
                                <table>
                                <tbody>
                                    <tr>
                                        <td className='text-right'>
                                        {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)}
                                        </td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                
                            <div className="row">
                                <div className="col-3">
                                    <img src={development? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />
                                    <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /><strong>{InfoByFolio && InfoByFolio.folio}</strong></p>
                                    <span className="text-left">Teléfono(s):  {user.Branch.Phone}</span>
                                    {/* <p>COL. C.P.;,.</p> */}
                                </div>
                                <div className="col-3"></div>
                                <div className="col-6">
                                    <table>
                                        <thead>
                                            <tr style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                <th className="text-left">FOLIO FISCAL: </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">{XML.isTimbra ?  XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.UUID : ''}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead>
                                            <tr style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                <th className="text-left">NO. SERIE DEL CSD: </th>
                                                <th className="text-left">NO. SERIE DEL CSD DEL SAT: </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">{XML.isTimbra ? XML.info._attributes.NoCertificado  : ''}</td>
                                                <td className="text-center">{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.NoCertificadoSAT : ''}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead>
                                            <tr style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                <th className="text-left">FECHA Y HORA DE CERTIFICACION: </th>
                                                <th className="text-left">FOLIO COUNTER ONE: </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.FechaTimbrado : ''}</td>
                                                <td className="text-center">{InfoByFolio && InfoByFolio.folio}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead>
                                            <tr style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                <th className="text-left">RÉGIMEN FISCAL: </th>
                                                <th className="text-left">FORMA DE PAGO: </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">{XML.isTimbra ? XML.info.cfdiEmisor._attributes.RegimenFiscal : ''}</td>
                                                <td className="text-center">{XML.isTimbra ? XML.info._attributes.FormaPago : ''}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='row mt-4' style={{ paddingRight: "15px" }}>
                            <p className="text-left" style={{fontSize: "14px", marginBottom: "-1px"}}>
                                {reprint?<><strong>REIMPRESION: </strong>{user.U_NAME} {time} </>:""}
                                {moment(DocHeader.DocDate).format('YYYY-MM-DD') ?? ''}
                            </p>
                                <table>
                                    <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                        <tr>
                                            <th className="text-center" colSpan="2">DATOS DEL CLIENTE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><strong>NOMBRE: </strong>{DocHeader && DocHeader.CardName}</td>
                                            <td><strong>CLAVE: </strong>{DocHeader && DocHeader.CardCode}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>DOMICILIO FACTURACIÓN: </strong>{DocHeader && DocHeader.BillDirection}</td>
                                            <td><strong>RUT: </strong>{DocHeader && DocHeader.LicTradNum}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>AGENTE: </strong></td>
                                            <td><strong>VENDEDOR INTERNO: </strong>{DocHeader && DocHeader.SlpName}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>MONEDA: </strong>{DocHeader && DocHeader.DocCur}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2"><strong>LUGAR DE ENTREGA: </strong>{DocHeader && DocHeader.ShipDirection}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table className='mt-5'>
                                    <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                        <tr>
                                            <th>#</th>
                                            <th>Cant.</th>
                                            <th className="text-center">Código</th>
                                            <th className="text-center">Descripción</th>
                                            <th>UM</th>
                                            <th>T.IMP</th>
                                            <th className="text-right">Precio</th>
                                            <th className="text-right">Importe</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {DocLines && DocLines.length > 0 &&
                                            DocLines.map((docLine, index) => {
                                                return (
                                                    <>
                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td>{Number(docLine.Quantity || 0).toFixed(4) ?? 0}</td>
                                                            <td className="text-center">{docLine.ItemCode ?? ''}</td>
                                                            <td className="text-center">{docLine.Dscription ?? ''}</td>
                                                            <td>{!!docLine.SalUnitMsr && docLine.SalUnitMsr}</td>
                                                            <td>T.IMP</td>
                                                            <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(docLine.Price) ?? ''}</td>
                                                            <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(docLine.Price * docLine.Quantity) ?? ''}</td>
                                                        </tr>
                                                        {docLine.U_FMB_LineComment != ""?
                                                            <tr>
                                                                <td ></td>
                                                                <td colSpan={7}><strong>Comentario: </strong>{docLine.U_FMB_LineComment}</td>
                                                            </tr>
                                                            :""
                                                        }
                                                    </>
                                                );
                                            })
                                        }


                                    </tbody>
                                </table>
                            </div>
                            <div className='row mt-3'>
                                <div className='col-9'>
                                    <p>
                                        Importe con letra: <br />
                                        {totalLetra}.<br />
                                        <br />
                                        <br />
                                        <br />
                                        <strong>"ESTE DOCUMENTO ES UNA REPRESENTACIÓN IMPRESA DE UN CFDI"</strong><br />
                                        <strong>Método de pago: </strong>{DocHeader && DocHeader.U_FMB_METODO_PAGO === 'PUE' ? 'PUE - Pago en una exhibición' : 'PPD - Pago en parcialidades o diferido' }<br />
                                        Comentarios: Basado en operación de Counter One CC0CCCAA2<br />
                                        <br />
                                    </p>
                                </div>
                                <div className='col-3'>
                                    <table>

                                        <tbody>
                                            <tr>
                                                <td className='text-right'><strong>Subtotal: </strong></td>
                                                <td className='text-right'>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal - DocHeader.VatSum) ?? ''}</td>
                                            </tr>
                                            <tr>
                                                <td className='text-right'><strong>Impuesto: </strong></td>
                                                <td className='text-right'>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.VatSum) ?? ''}</td>
                                            </tr>
                                            <tr>
                                                <td className='text-right'><strong>Total: </strong></td>
                                                <td className='text-right'>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal) ?? ''}</td>
                                            </tr>
                                            <tr>
                                                <td className='text-right'><strong>Importe Bruto: </strong></td>
                                                <td className='text-right'>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal - DocHeader.VatSum) ?? ''}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='row' style={{ marginLeft: "-30px" }}>
                                <div className='col-12'>
                                    <table>
                                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                            <tr>
                                                <th className="text-center">Sello Digital del Emisor:</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className='digitalStampMax'>
                                                {XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.SelloCFD : ''}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='row mt-2' style={{ marginLeft: "-30px" }}>
                                <div className='col-12'>
                                    <table>
                                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                            <tr>
                                                <th className="text-center">Sello Digital del SAT:</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className='digitalStampMax'>
                                                {XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.SelloSAT : ''}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='row mt-2' style={{ marginLeft: "-30px" }}>
                                <div className='col-12'>
                                    <table>
                                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                            <tr>
                                                <th className="text-center">Cadena Original del complemento de certificación digital del SAT</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className='digitalStampMax'>
                                                    {cfdiCaComplemento}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </td></tr></table>
            
        )
    }
}

export default DownPayment